import React from 'react';
import BrandLoader from 'shared/components/ui/BrandLoader';

export const BrandLoaderInline = ({ label }) => (
  <div className="flex justify-center py-8">
    <BrandLoader label={label} size="md" />
  </div>
);
